export default {
    computed: {
        today() {
            return this.$moment()
        }, 
        tomorrow() {
            return this.$moment().add(1,'days')
        },
        twoDays() {
            return this.$moment().add(2,'days')
        },
        threeDays() {
            return this.$moment().add(3,'days')
        }
    }
}